import React from "react";
import { makeStyles } from "@material-ui/core";
import ChevronRight from "@material-ui/icons/ChevronRight";
import ExpandMore from "@material-ui/icons/ExpandMore";

export function ToggleButton({ toggle, isOpen, hasChildren, isSelected }) {
    const classes = useStyles()

    if (hasChildren) {
        const Icon = isOpen ? ExpandMore : ChevronRight;
        return (
            <div className={classes.toggleBtn} tabIndex={-1} onClick={toggle}>
                <Icon fontSize={"inherit"} />
            </div>
        );
    } else {
        return <div className={classes.spacer} />;
    }
}

const useStyles = makeStyles(() => ({
    spacer: {
        width: 15
    },
    toggleBtn: {
        fontSize: 15,
        width: 15,
        display: "flex",
        alignItems: "center"
    },
}))